export default __webpack_public_path__ + "static/img/rooms-bg.f98140d.png";